
import { defineComponent, inject, onMounted, ref } from "vue";
import { Chart, registerables } from "chart.js";
import { useStore } from "vuex";
import dayjs from "dayjs";
import "v-calendar/dist/style.css";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { useRoute, useRouter } from "vue-router";
import { on } from "events";
Chart.register(...registerables);

export default defineComponent({
  name: "HomeView",
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    // ChevronDownIcon,
  },
  setup() {
    const axios: any = inject("$axios");
    let store = useStore();
    let route = useRoute();
    let router = useRouter();
    let date = ref(dayjs().format('YYYY-MM-DD'));
    let data = ref()
    let currentPage = ref(1)
    let masks = ref({
      modelValue: 'YYYY-MM-DD',
    });

    onMounted(() => {
      if (route.params && route.params.date) {
        date.value = dayjs(Array.isArray(route.params.date) ? route.params.date[0] : route.params.date).format('YYYY-MM-DD')
      }
      getData();
    })

    const getData = async () => {
      return axios
        .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/dashboard/provider", {
          operatorId: store.state.selectedOperator.operatorId,
          date: dayjs(date.value.toString()).format('YYYY-MM-DD'),
          moduleCode: route.params.providerId,
          page: currentPage.value,
          size: 20
        })
        .then(async (response: any) => {
          data.value = response.data.result;
          setTimeout(async () => {
            await getData()
          }, 60 * 1000);
        })
        .catch((err: any) => {
          console.log(err);
          return [];
        });
    };

    const goBack = () => {
      router.push({
        name: "Realtime Dashboard Index", // หรือ "Realtime Dashboard"
        params: {
          date: date.value // ส่งค่า date ไปด้วย
        }
      });
    };

    return {
      currentPage,
      route,
      router,
      date,
      data,
      masks,
      getData,
      goBack
    };
  },
});
